import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';

import '../SignRiderTemplate.css';

const styles = {
  card: {
    maxWidth: 500,
  },
  text: {
    fontFamily: 'itcAvantGarde',
    padding: 15,
  },
  headText: {
    fontSize: '2.6em',
    paddingTop: 20,
    paddingBottom: 10,
  },
  cardContent: {
    padding: '0 !important',
  },
  number: {
    fontSize: '1.5em',
  },
  textTo: {
    fontSize: '1.9em',
    marginBottom: 0,
  },
};

const SignRiderTemplate = props => {
  const { classes, phoneNumber, template } = props;
  const { topStrokeColor, bottomStrokeColor } = template.styles;

  const modPhoneNumber = phoneNumber => {
    return phoneNumber.split('').reduce((number, currNumber, i) => {
      if (i >= 2) {
        i === 5 || i === 8
          ? (number += `-${currNumber}`)
          : (number += currNumber);
      } else {
        number = '';
      }
      return number;
    });
  };

  const borderBottom = template.hasCenterLine
    ? `8px solid ${template.centerLineColor} `
    : `none`;

  const topStyles = {
    color: template.styles.fontColorTop,
    background: template.styles.topBgColor,
    textShadow: `-1px 0 ${topStrokeColor}, 0 1px ${topStrokeColor}, 1px 0 ${topStrokeColor}, 0 -1px ${topStrokeColor}`,
    borderBottom,
  };
  if (template.hasCenterLine) topStyles.paddingBottom = 0;
  const bottomStyles = {
    color: template.styles.fontColorBottom,
    background: template.styles.bottomBgColor,
    textShadow: `-1px 0 ${bottomStrokeColor}, 0 1px ${bottomStrokeColor}, 1px 0 ${bottomStrokeColor}, 0 -1px ${bottomStrokeColor}`,
  };

  const textNumber = (
    <span style={bottomStyles} className={classes.number}>
      100
    </span>
  );

  const _phoneNumber = (
    <span style={bottomStyles} className={classes.number}>
      {modPhoneNumber(phoneNumber)}
    </span>
  );
  return (
    <Card id={template.id} className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Typography
          className={`${classes.headText} ${classes.text}`}
          style={topStyles}
          variant="headline"
          component="h1"
          align="center"
        >
          For INSTANT Info {`&`} Pictures
        </Typography>
        <Typography
          className={`${classes.text} ${classes.textTo}`}
          style={bottomStyles}
          variant="headline"
          component="h2"
          align="center"
        >
          text: {textNumber} to: {_phoneNumber}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(SignRiderTemplate);



// WEBPACK FOOTER //
// ./src/components/SignRiderTemplate.js